"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ListItem = require("./ListItem.styles");
var _events = require("../../../../utilities/events");
var _Checkbox = require("../../../../UI/Checkbox");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ListItem = props => {
  const ref = (0, _react.useRef)(null);
  const {
    children,
    isDisabled,
    isSelected,
    id,
    role = 'listitem',
    isFocused = false,
    isWithCheckbox = false,
    checkboxVerticalAlign = 'top',
    color,
    size,
    isSeparator = false,
    onClick,
    onDisabledClick,
    onMouseEnter,
    onMouseLeave,
    className = ''
  } = props;
  const styles = (0, _ListItem.useStyles)(props);
  const handleClick = event => {
    event?.stopPropagation();
    if (isDisabled) {
      if (onDisabledClick) {
        onDisabledClick();
      }
    } else if (onClick) {
      onClick(id);
    }
  };
  const handleKeyDown = event => {
    (0, _events.handleSpaceOrEnterDown)(event, handleClick);
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        let nextElement = event.target.nextElementSibling;
        while (nextElement?.getAttribute('tabIndex') === '-1') {
          nextElement = nextElement.nextElementSibling;
        }
        if (nextElement) {
          nextElement.focus();
        }
        break;
      case 'ArrowUp':
        event.preventDefault();
        let prevElement = event.target.previousElementSibling;
        while (prevElement?.getAttribute('tabIndex') === '-1') {
          prevElement = prevElement.previousElementSibling;
        }
        if (prevElement) {
          prevElement.focus();
        }
        break;
      default:
        break;
    }
  };
  const handleMouseEnter = event => {
    if (!isDisabled) {
      if (onMouseEnter) {
        onMouseEnter(event);
      }
    }
  };
  const handleMouseLeave = event => {
    if (!isDisabled) {
      if (onMouseLeave) {
        onMouseLeave(event);
      }
    }
  };
  (0, _react.useEffect)(() => {
    setTimeout(() => {
      if (isFocused && ref?.current) {
        ref?.current.focus();
      }
    }, 0);
  }, [isFocused]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
    className: `${styles['cc-ListItem']} ${className}`.trimEnd(),
    ref: ref,
    role: role,
    "data-value": id,
    "data-testid": "ccListItem",
    tabIndex: isDisabled || isSeparator ? -1 : 0,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "aria-selected": isSelected,
    children: isWithCheckbox ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.Checkbox, {
      id: id,
      isChecked: Boolean(isSelected),
      isDisabled: isDisabled,
      tabIndex: -1,
      verticalAlign: checkboxVerticalAlign,
      color: color,
      size: size,
      label: children,
      onClick: () => {
        return false;
      }
    }) : children
  }, `cc-ListItem--${id}`);
};
exports.ListItem = ListItem;